<template>
	<div class="select-nft-container p-1  d-flex align-items-center  justify-content-center" @click="toggleSelect">
		<div v-if="!selectedNft.id" class="nft-select animate__animated animate__fadeIn">
			<span>Select NFT</span>
		</div>

		<div v-else class="col-12">
			<div class="row d-flex align-items-center">
				<div class="col-auto pe-0">
					<div class="col-hover d-flex align-items-center animate__animated animate__fadeIn select-inner ms-2">
						<div class="nft-preview-small" :style="previewStyle"></div>
						<h4 class="mb-0 ms-2 token-name">{{ nftName }}</h4>
						<i class="fa fa-angle-down mx-2 mt-1"></i>
					</div>
				</div>
				<div class="col col-always text-end ps-0">
					<input :readonly="true" placeholder="0.00" min="0.00" :value="1" class="form-control fw-bold">
					<p class="mb-0 small balance">
						<span class="">${{ usdcFloorPrice.toFixed(2) }}</span>
					</p>
				</div>
			</div>
		</div>

		<portal to="body">
			<SelectNFT :filter="filter" @close="toggleSelect" @selected="onSelect" v-if="showSelect"></SelectNFT>
		</portal>
	</div>
</template>

<script>
import SelectNFT from "@/components/nft/SelectNFT";
import {getNftStats} from "@alphabatem/liquifynft-sdk";
import {WSOL} from "@/api/token_swap/constants";

export default {
	name: "SelectNFTContainer",
	components: {SelectNFT},
	props: {
		filter: {
			type: String
		}
	},
	data() {
		return {
			showSelect: false,
			stats: {
				collection: null,
				lastSalePrice: 0.0,
				purchaseDate: null,
			},
		}
	},
	computed: {
		floorPrice: function () {
			if (!this.stats.collection)
				return 0.0

			if (this.$store.state.cache.nftPrices[this.stats.collection.id])
				return this.$store.state.cache.nftPrices[this.stats.collection.id]

			return 0.0
		},

		usdcFloorPrice: function () {
			const price = this.$store.state.cache.tokenPrices[WSOL.toString()]?.price || 0
			return this.floorPrice * price
		},

		purchaseDate: function () {
			if (!this.stats.purchaseDate || this.stats.purchaseDate === "0001-01-01T00:00:00Z")
				return "-"

			return new Date(this.stats.purchaseDate).toLocaleDateString()
		},

		selectedNft: function () {
			return this.$store.state.nft_swap.selected_nft || {}
		},

		nftName: function () {
			let name = this.selectedNft.name
			if (name === "") {
				name = this.selectedNft.metadata?.name || this.selectedNft.metadata.collection?.name || this.selectedNft.symbol || ""
			}

			let add = ""
			if (name.length > 22)
				add = "..."

			return `${name.slice(0, 22)}${add}`
		},
		collectionName: function () {
			const n = this.selectedNft.collection ? this.selectedNft.collection : this.selectedNft.metadata.collection ? this.selectedNft.metadata.collection.name : 'Unknown'
			return n.slice(0, 22)
		},
		previewStyle: function () {
			if (!this.selectedNft)
				return {}

			const link = `https://api.degencdn.com/v1/nfts/${this.selectedNft.mint}/image.jpg`
			return {
				// backgroundImage: `url("${this.selectedNft.image}")`
				backgroundImage: `url("${link}")`,

			}
		}
	},
	methods: {
		toggleSelect: function () {
			this.showSelect = !this.showSelect
		},
		onSelect: function (key) {
			console.log("onNFTSelect", key)
			this.$store.commit("nft_swap/set_nft", key)
			this.$store.commit("nft_swap/set_available_routes");

			this.showSelect = false
			console.log(`selected nft `, key)

			getNftStats(this.selectedNft.id).then(j => {
				this.stats = j
			}).catch(() => {
				this.$toastr.e("Please try again later", "Unable to fetch nft detail")
			}).finally(() => {
				this.$emit("selected", key, this.stats)
			})

		},
	}
}
</script>

<style scoped>
.select-nft-container {
	background: var(--bs-dark);
	cursor: pointer;
	transition: all 0.3s ease;
	border-radius: 7px;
	min-height: 77px;
}

.select-inner {
	border-radius: 7px;
}

.placeholder-text {
	font-weight: bold;
	justify-content: space-evenly;
}

.col-hover:hover {
	filter: brightness(1.3);
	background: rgba(255, 255, 255, 0.4);
}

.col-hover {
	background: rgba(255, 255, 255, 0.2);
	transition: all 0.3s ease-in-out;
}

tr :first-child {
	text-align: start;
}

.stats-container p {
	text-align: left;
}

.form-control {
	text-align: right;
	border: none;
	line-height: 1rem;
	/*font-size: 1.75rem;*/
	font-size: 3rem;
	padding: 0;
}

input.form-control[readonly] {
	background: transparent;
}

.form-control:disabled, .form-control[readonly] {
	background: transparent;
}

input[type=number] {
	-moz-appearance: textfield;
}
</style>